import React from 'react'

const TrafficManagementHero = () => {
    return (
        <section className="lg:py-28 lg:px-12 px-5 py-28 bg-bgDefault text-white ">
            <div className='container xl:mx-auto xl:max-w-screen-xl'>
                <div className='grid grid-cols-12 gap-8'>
                    <div className='col-span-12 md:col-span-6'>
                        <h2 className="text-heading-4 lg:text-heading-1 font-dmsans font-bold tracking-[-0.06em] mb-8 ">
                            Traffic Data Management System
                        </h2>
                         <div className="flex flex-wrap gap-2 mt-2 mb-6">
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Spring Boot
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Angular
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                ArcGIS
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                PostgreSQL
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                AWS
                            </span>
                        </div>
                         <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto ">
                              We partnered with a Middle Eastern Ministry of Road Transportation to architect a mission-critical Traffic
                              Data Management System (TDMS) that successfully enabled smooth traffic flow during FIFA World Cup 2022. Built
                              with Spring Boot, Angular, and PostgreSQL with ArcGIS API integration, the platform processes traffic data from
                              500,000+ vehicles daily, reduced data breach risks by 40%, and delivered GIS-based visualizations crucial to
                              the Ministry's Master Plan. Deployed on AWS Cloud with Docker containerization, the solution provided accurate,
                              real-time traffic insights that transformed infrastructure planning and established new standards for
                              government-scale traffic management systems.
                            </p>

                    </div>
                    <div className='col-span-12 md:col-span-6'>
                      <img src='/case_studies/title-banner/traffic-app-title-banner.png' alt='Traffic Data Management System' className='w-full h-auto'></img>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TrafficManagementHero
